import { ChevronLeftCircle, ChevronRightCircle } from 'lucide-react';
import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';

export default function PanduanAplikasi() {
  const [visibleSections, setVisibleSections] = useState(new Set());
  const [filter, setFilter] = useState('all');
  const [panduan, setPanduan] = useState([]);
  const [selectedPanduan, setSelectedPanduan] = useState(null);
  const [currentIndex, setCurrentIndex] = useState(0);

  useEffect(() => {
    const handleScroll = () => {
      const sections = document.querySelectorAll('[data-section]');
      sections.forEach(section => {
        const rect = section.getBoundingClientRect();
        const isVisible = rect.top < window.innerHeight * 0.75 && rect.bottom > 0;
        
        if (isVisible) {
          setVisibleSections(prev => new Set([...prev, section.getAttribute('data-section')]));
        }
      });
    };

    window.addEventListener('scroll', handleScroll);
    handleScroll();
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const fetchPanduan = async () => {
    try {
      const res = await fetch(`${process.env.REACT_APP_BASE_URL}api/panduan`);

      if (!res.ok) {
        throw new Error(`HTTP error! status: ${res.status}`);
      }

      const note = await res.json();
      const list = Array.isArray(note) ? note : note.data || [];

      setPanduan(list);
    } catch (err) {
      console.error("Gagal mengambil data:", err);
    }
  };
  
  useEffect(() => {
    fetchPanduan();
  }, []);

  const steps = selectedPanduan
  ? Array.from({ length: 10 }, (_, i) => ({
      step: selectedPanduan[`step${i + 1}`],
      image: selectedPanduan[`image${i + 1}`],
    })).filter((item) => item.step && item.image)
  : [];

  return (
    <div className="min-h-screen bg-slate-950 text-white pt-20">
      {/* Header Section */}
      <section 
        data-section="header"
        className="py-24 bg-gradient-to-b from-slate-900 to-slate-950 relative overflow-hidden"
      >
        <div className="absolute inset-0">
          <div className="absolute top-1/4 right-1/4 w-96 h-96 bg-blue-600/10 rounded-full blur-3xl"></div>
        </div>

        <div className={`relative max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 text-center transition-all duration-1000 ${
          visibleSections.has('header') ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-10'
        }`}>
          <h1 className="text-5xl md:text-6xl font-bold mb-6 bg-gradient-to-r from-blue-400 to-red-400 bg-clip-text text-transparent">
            Panduan Aplikasi Android Radar Pulsa APK
          </h1>
          <div className="w-24 h-1 bg-gradient-to-r from-blue-500 to-red-500 mx-auto mb-6"></div>
          {/* <p className="text-xl text-gray-400 max-w-3xl mx-auto">
            Showcasing our best work and successful project deliveries across various industries
          </p> */}
        </div>
      </section>

      {/* Filter Section */}
      {/* <section 
        data-section="filter"
        className="py-8 bg-slate-950"
      >
        <div className={`max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 transition-all duration-1000 delay-200 ${
          visibleSections.has('filter') ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-10'
        }`}>
          <div className="flex flex-wrap justify-center gap-4">
            {categories.map((category) => (
              <button
                key={category.id}
                onClick={() => setFilter(category.id)}
                className={`px-6 py-3 rounded-lg font-semibold transition-all duration-300 transform hover:scale-105 ${
                  filter === category.id
                    ? 'bg-gradient-to-r from-blue-600 to-red-600 text-white shadow-lg shadow-blue-500/50'
                    : 'bg-slate-800 text-gray-400 hover:text-white hover:bg-slate-700'
                }`}
              >
                {category.name}
              </button>
            ))}
          </div>
        </div>
      </section> */}

      {/* Projects Grid */}
      <section 
        data-section="projects"
        className="py-16 bg-slate-950"
      >
        <div className={`max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 transition-all duration-1000 delay-300 ${
          visibleSections.has('projects') ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-10'
        }`}>
          {Array.isArray(panduan) && panduan.map((a, idx) => (
            <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-8">
              <div
                key={idx}
                className="group relative overflow-hidden rounded-2xl bg-slate-800/50 border border-slate-700 hover:border-blue-500/50 transition-all duration-500 transform hover:scale-105"
                style={{ 
                  transitionDelay: `${1 * 100}ms`,
                  animation: 'fadeIn 0.5s ease-out'
                }}
              >
                <div className={`aspect-video bg-gradient-to-br from-blue-600 to-indigo-600 relative overflow-hidden`}>
                  <div className="absolute inset-0 flex items-center justify-center">
                    <span className="text-6xl font-bold text-white/20">Panduan Aplikasi</span>
                  </div>
                  <div className="absolute inset-0 bg-gradient-to-t from-slate-900 to-transparent opacity-0 group-hover:opacity-100 transition-opacity duration-300"></div>
                  
                  {/* Hover Overlay */}
                  <div className="absolute inset-0 flex items-center justify-center opacity-0 group-hover:opacity-100 transition-opacity duration-300">
                    <button 
                    onClick={() => {
                      setSelectedPanduan(a);
                      setCurrentIndex(0);
                    }}
                    className="px-6 py-3 bg-white text-slate-900 rounded-lg font-semibold hover:bg-gray-100 transition-colors duration-300">
                      Lihat Panduan
                    </button>
                  </div>
                </div>
                
                <div className="p-6">
                  <h3 className="text-xl font-bold mb-2 text-white group-hover:text-blue-400 transition-colors duration-300">
                    {a.title}
                  </h3>
                </div>
              </div>              
            </div>            
            ))
          }
        </div>
      </section>

      {/* CTA Section */}
      <section 
        data-section="cta"
        className="py-24 bg-gradient-to-b from-slate-900 to-slate-950 relative overflow-hidden"
      >
        <div className="absolute inset-0">
          <div className="absolute top-1/2 left-1/2 transform -translate-x-1/2 -translate-y-1/2 w-96 h-96 bg-blue-600/20 rounded-full blur-3xl"></div>
        </div>

        <div className={`relative max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 text-center transition-all duration-1000 delay-400 ${
          visibleSections.has('cta') ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-10'
        }`}>
          <h2 className="font-bricolage text-4xl md:text-5xl font-bold mb-6 bg-gradient-to-r from-blue-400 to-red-400 bg-clip-text text-transparent">
            Ayo bergabung menjadi mitra Kami!
          </h2>
          <p className="text-xl text-gray-400 mb-8">
            Kami tidak hanya menyediakan layanan, tetapi membangun kemitraan jangka panjang untuk perkembangan bisnis Anda.
          </p>
          <Link 
            to="/contact"
            className="inline-block px-10 py-4 bg-gradient-to-r from-blue-600 to-red-600 rounded-full font-semibold text-lg hover:shadow-2xl hover:shadow-blue-500/50 transform hover:scale-105 transition-all duration-300"
          >
            Mulai mendaftar
          </Link>
        </div>
      </section>

      <style jsx>{`
        @keyframes fadeIn {
          from {
            opacity: 0;
            transform: translateY(20px);
          }
          to {
            opacity: 1;
            transform: translateY(0);
          }
        }
      `}</style>
      {selectedPanduan && (
        <div className="fixed inset-0 z-50 flex items-center justify-center">

          {/* Glass Background */}
          <div
            className="absolute inset-0 bg-black/40 backdrop-blur-xl"
            onClick={() => setSelectedPanduan(null)}
          />

          {/* Modal Content */}
          <div className="relative w-[90%] md:w-[80%] lg:w-[70%] h-[80vh] bg-white/10 backdrop-blur-2xl border border-white/20 rounded-2xl overflow-hidden shadow-2xl">

            {/* Close Button */}
            <button
              onClick={() => setSelectedPanduan(null)}
              className="absolute top-4 right-4 z-50 text-white text-2xl"
            >
              ✕
            </button>

            {/* Slider Content */}
            <div className="relative w-full h-full flex items-center justify-center overflow-hidden">

              {/* Slide */}
              <div
                className="w-full h-full flex transition-transform duration-500 ease-in-out"
                style={{
                  transform: `translateX(-${currentIndex * 100}%)`
                }}
              >
                {steps.map((item, index) => (
                  <div
                    key={index}
                    className="w-full p-4 flex-shrink-0 flex flex-col items-center justify-center gap-4"
                  >
                    <span className="text-md font-semibold max-w-xl text-center">{item.step}</span>

                    <img
                      src={`${process.env.REACT_APP_BASE_URL}uploads/images/${item.image}`}
                      alt=""
                      className="h-[50vh] object-contain"
                    />
                  </div>
                ))}
              </div>

              {/* Navigation Buttons */}
              <button
                onClick={() =>
                  setCurrentIndex((prev) =>
                    prev === 0 ? steps.length - 1 : prev - 1
                  )
                }
                className="absolute left-4 text-white text-3xl transform hover:scale-125 duration-500"
              >
                <ChevronLeftCircle size={48} />
              </button>

              <button
                onClick={() =>
                  setCurrentIndex((prev) =>
                    prev === steps.length - 1 ? 0 : prev + 1
                  )
                }
                className="absolute right-4 text-white text-3xl transform hover:scale-125 duration-500"
              >
                <ChevronRightCircle size={48} />
              </button>

            </div>
          </div>
        </div>
      )}
    </div>
    
  );
}
